export const slides = [
	{
		bgImage: "/images/backgrounds/lunarclient.png",
		icon: "/images/logos/lunarclient.png",
		title: "Lunar Client",
		description: "A modpack for all modern versions of Minecraft.",
		link: "https://lunarclient.com",
		link_text: "Download"
	},
	{
		bgImage: "/images/backgrounds/mcstats.png",
		icon: "/images/logos/mcstats.png",
		title: "MCStats",
		description: "A Minecraft skin service to use in your products.",
		link: "https://skins.mcstats.com",
		link_text: "Explore"
	},
	{
		bgImage: "/images/backgrounds/resourcepacks.png",
		icon: "/images/logos/resourcepacks.png",
		title: "Resourcepacks",
		description: "A website to find and download Minecraft resourcepacks.",
		link: "https://resourcepacks.gg",
		link_text: "Explore"
	}
];
